import CloseIcon from '@mui/icons-material/Close';
import { Autocomplete } from '@mui/material';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import Button, { ButtonWrapper } from 'blocks/Button';
import Form, { SelectField } from 'components/Form';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import urls from 'utils/urls';
import { ModalSearchProps, products, searchFormModel } from '../ProductBooking.interface';
import * as S from './modalSearchMerchant.styles';
const ModalSearch: ModalFC<ModalSearchProps> = ({ open, onClose, onSearch, onClear, paramsObj }) => {
  const { register, setValue, handleSubmit, getValues } = useForm<searchFormModel>();
  const selectedStatus = useRef<any>(null);
  const [products, setProducts] = useState<products[]>([]);
  const [inputProductValue, setInputProductValue] = useState('');
  const [options, setOptions] = useState<any>([]);
  const [ProductValue, setProductValue] = useState<products[]>([]);
  const { t } = useTranslation();
  const getProducts = async (name = '') => {
    axios
      .get(urls.product + `?name=${name}`)
      .then((res) => {
        if (!res) return;
        const ps = res.data.response.data;
        setProducts(ps);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (inputProductValue === '') {
      setOptions(ProductValue ? [ProductValue] : []);
      return undefined;
    }
    getProducts(inputProductValue);
  }, [inputProductValue]);
  const handleSetFilter = (data: searchFormModel) => {
    if (selectedStatus.current) {
      paramsObj = { ...paramsObj, status: selectedStatus.current };
    }
    paramsObj.productId = ProductValue.map((i) => i.id);
    onSearch && onSearch(paramsObj);
  };

  const handleClearFilter = () => {
    onClear();
    onClose && onClose();
    selectedStatus.current = [];
    setProductValue([]);
  };

  const onSelectStatus = (items: Array<any>) => {
    selectedStatus.current = items.map((i) => i.value);
    setValue(
      'status',
      items.map((i) => i.title)
    );
  };
  const STATUS_MENU = [
    { title: 'purchased', value: 'purchased' },
    { title: 'pending', value: 'pending' },
    { title: 'delivery', value: 'delivery' },
  ];

  return (
    <Modal open={open} onClose={onClose}>
      <Form>
        <div className="autocompletemui">
          <label style={{ color: '#97A3BA', fontSize: '12px' }}>
            {t('pages.services.Products.sections.Booking.sections.modals.fields.ProductList.label')}{' '}
          </label>
          <Autocomplete
            multiple
            id="fixed-tags"
            value={ProductValue}
            onChange={(event, newValue) => {
              setProductValue(newValue);
            }}
            onInputChange={(event, newInputValue) => {
              setInputProductValue(newInputValue);
            }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={products}
            filterSelectedOptions
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.name}
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip label={option.name} {...getTagProps({ index })} deleteIcon={<CloseIcon />} size="small" />
              ))
            }
            style={{ width: '100%', border: '1px solid  rgb(216,223,237)', borderRadius: '4px' }}
            renderInput={(params) => <TextField variant="standard" {...params} placeholder="search..." />}
          />
        </div>
        <div style={{ margin: '1rem 0rem' }}>
          <SelectField
            control={register('status')}
            multiSelect
            label={t('pages.services.Products.sections.Booking.sections.modals.fields.Status.label')}
            menu={STATUS_MENU}
            onChange={(value: string) => {
              setValue('status', [...(getValues('status') || []), value]);
            }}
            onSelect={onSelectStatus}
            defaultValue={selectedStatus.current || []}
          />
        </div>

        <S.ButtonWrapper as={ButtonWrapper} justify="flex-end">
          <S.Button
            as={Button}
            onClick={handleSubmit((data) => {
              handleSetFilter(data);
              onClose && onClose();
            })}
          >
            {t('pages.miles.view.sections.filters.submitCTA')}
          </S.Button>
          <S.Button as={Button} color="outlined" onClick={handleClearFilter}>
            {t('pages.miles.view.sections.filters.clearCTA')}
          </S.Button>
        </S.ButtonWrapper>
      </Form>
    </Modal>
  );
};

export default ModalSearch;
